import { LineString } from "ol/geom";
// A helper function to compute an offset LineString.
// "offset" is the distance you want to shift (positive value shifts to the left).
function offsetLineString(lineString, offset) {
  const coords = lineString.getCoordinates();
  const offsetCoords = [];
  for (let i = 0; i < coords.length; i++) {
    const p = coords[i];
    let angle;
    if (i === 0) {
      // For the first vertex, use the angle of the first segment.
      const p2 = coords[i + 1];
      angle = Math.atan2(p2[1] - p[1], p2[0] - p[0]);
    } else if (i === coords.length - 1) {
      // For the last vertex, use the angle of the previous segment.
      const p1 = coords[i - 1];
      angle = Math.atan2(p[1] - p1[1], p[0] - p1[0]);
    } else {
      // For vertices in the middle, average the angles of the previous and next segments.
      const p1 = coords[i - 1];
      const p2 = coords[i + 1];
      const angle1 = Math.atan2(p[1] - p1[1], p[0] - p1[0]);
      const angle2 = Math.atan2(p2[1] - p[1], p2[0] - p[0]);
      angle = (angle1 + angle2) / 2;
    }
    // Compute the perpendicular (left) offset.
    const offsetX = offset * Math.cos(angle - Math.PI / 2);
    const offsetY = offset * Math.sin(angle - Math.PI / 2);
    offsetCoords.push([p[0] + offsetX, p[1] + offsetY]);
  }
  return new LineString(offsetCoords);
}
export function shiftLeft(feature, resolution, pixelOffset) {
  var geom = feature.getGeometry();
  if (geom.getType() === "LineString") {
    // Adjust the second parameter to set how far left you want the line shifted.
    const realOffset = pixelOffset * resolution;
    return offsetLineString(geom, -realOffset);
  }
  return geom;
}
export function shiftRight(feature, resolution, pixelOffset) {
  var geom = feature.getGeometry();
  if (geom.getType() === "LineString") {
    // Adjust the second parameter to set how far left you want the line shifted.
    const realOffset = pixelOffset * resolution;
    return offsetLineString(geom, realOffset);
  }
  return geom;
}
